import React, { useState } from "react";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import { useGetAnalystAssignmentsQuery } from "../../../redux/service/modules/admin";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import AnalystAssignmentDialog from "./AnalystAssignmentDialog";
const AnalystAssignmentDetail = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);

    return (
        <Layout>
            <CustomAdminLayout
                title={"Analyst Assignment"}
                createButtonText={"Add New Analyst Assignment"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Analyst Assignment"}
            >
                <PaginatedDataTable
                    queryHook={useGetAnalystAssignmentsQuery}
                    title="Analyst Assignment"
                    paginationEnabled={true}
                    showEditColumn={true}
                    showCheckboxColumn={false}
                    appliedFilters={{ search: searchText }}
                    dialogType={"analystAssignment"}
                />
                <AnalystAssignmentDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New Analyst Assignment"}
                    ctaText={"ADD ANALYST ASSIGNMENT"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default AnalystAssignmentDetail;
